import { motion } from "framer-motion";
import portrait2 from "../assets/portrait2.jpg";
import portrait3 from "../assets/portrait3.jpg";
import portrait13 from "../assets/portrait13.jpeg";
import portrait15 from "../assets/portrait15.jpeg";
import portrait16 from "../assets/portrait16.jpeg";
import portrait17 from "../assets/portrait17.jpeg";
import portrait19 from "../assets/portrait19.jpeg";
import portrait7 from "../assets/portrait7.jpeg";
import portrait8 from "../assets/portrait8.jpeg";
import portrait6 from "../assets/portrait6.jpeg";
import portrait10 from "../assets/portrait10.jpeg";
import portrait18 from "../assets/portrait18.jpeg";
import portrait25 from "../assets/portrait25.jpg";
import moment1 from "../assets/moment1.jpg";

const images = [
  portrait2,
  portrait3,
  portrait6,
  portrait16,
  portrait13,
  portrait15,
  portrait19,
  portrait7,
  portrait17,
  portrait8,
  portrait10,
  portrait18,
  portrait25,
  moment1,
  portrait2,
  portrait3,
  portrait6,
  portrait16,
  portrait13,
  portrait15,
  portrait19,
  portrait7,
  portrait17,
  portrait8,
  portrait10,
  portrait18,
  portrait25,
  moment1,
];

const displayImages = [...images, ...images];

const FilmStrip = () => {
  return (
    <div className="py-12 bg-dreamy-cream border-y border-dreamy-gold/20 overflow-hidden flex whitespace-nowrap">
      <motion.div
        // Use percentages instead of hardcoded pixels
        animate={{ x: ["0%", "-50%"] }}
        transition={{
          repeat: Infinity,
          duration: 100, // Increase duration for a slower, "dreamier" feel
          ease: "linear",
        }}
        className="flex gap-4 pr-4"
      >
        {displayImages.map((src, index) => (
          <div
            key={index}
            className="w-48 h-32 md:w-64 md:h-40 flex-shrink-0 rounded-sm overflow-hidden shadow-md border-[6px] border-white"
          >
            <img
              src={src}
              className="w-full h-full object-cover brightness-95 contrast-90 grayscale-[20%]"
              alt={`Vintage shot ${index}`}
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default FilmStrip;
